module.exports = __webpack_public_path__ + "static/media/icon--outlook.9fa7d6d4.svg";